import { ApiResourceBaseClass as e } from "./baseApiCalls.js";
const o = "custom_role";
class R extends e {
  /**
   * Get the paginated list of custom roles
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/custom_role`
   *
   * @param {GetCustomRolesParams} queryParams - the params for pagination and org_id
   * @returns {Promise<GetCustomRolesResponse>} A promise that resolves to the data containing the custom roles.
   */
  getCustomRoles = async (s) => {
    const { data: t } = await this.get(
      `${o}`,
      s
    );
    return t;
  };
}
export {
  o as CUSTOM_ROLE_RESOURCE_URI,
  R as CustomRoles
};
